function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
var VideoBanner = function VideoBanner(_ref) {
  var settings = _ref.settings,
    component = _ref.component;
  var defaultDictionary = {
    Shared: {
      videoCannotBeLoadedDueToCookieConsentError: ''
    }
  };
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hasConsent = _useState2[0],
    setConsent = _useState2[1];
  var _useState3 = useState(defaultDictionary),
    _useState4 = _slicedToArray(_useState3, 2),
    dictionary = _useState4[0],
    setDictionary = _useState4[1];
  useEffect(function () {
    // grab dictionary items
    window.DGS.Dictionary.getInstance().getTexts(defaultDictionary, function () {
      setDictionary(defaultDictionary);
    });
    var checkConsent = function checkConsent(e) {
      var consentGiven = window.CookieInformation === undefined ? true : window.CookieInformation.getConsentGivenFor('cookie_cat_marketing');
      setConsent(consentGiven === undefined ? true : consentGiven);
    };
    window.addEventListener('CookieInformationConsentGiven', checkConsent);
    return function () {
      // cleanup
      window.removeEventListener('CookieInformationConsentGiven', checkConsent);
    };
  }, []);

  /**
   * resizes the iframe containing our video to grow no bigger than our content allows.
   */
  useEffect(function () {
    // resize iframe
    var iframe = component.querySelector('iframe');
    var parent = iframe.parentElement;
    if (iframe) {
      var w = settings.embeddedVideo.width;
      var h = settings.embeddedVideo.height;
      var wW = w > parent.clientWidth ? parent.clientWidth : w;
      var prop = w / h;
      w = wW;
      h = w / prop;
      iframe.height = h;
      iframe.width = w;
    }
  });
  var isMobile = function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  };
  var minHeight = isMobile() ? 0 : settings.image.height;
  var mobileStyle = isMobile() ? 'is-mobile' : '';
  var anchorStyle = !isMobile() && settings.anchorLink ? 'has-anchor' : '';
  var backgroundImage = function backgroundImage() {
    if (isMobile() && settings.mobileImage && settings.mobileImage.src) {
      return "url(".concat(settings.mobileImage.src, ")");
    }
    return "url(".concat(settings.image.src, ")");
  };
  var renderAnchorLink = function renderAnchorLink() {
    if (settings.anchorLink) {
      return /*#__PURE__*/React.createElement("div", {
        className: "sticky-downlink"
      }, /*#__PURE__*/React.createElement("a", {
        href: settings.anchorLink.href,
        className: "disc-down"
      }, " "));
    }
    return null;
  };
  var renderContentSection = function renderContentSection() {
    // css will render direction of columns
    if (!isMobile() && (component.classList.contains('video-right') || component.classList.contains('video-left'))) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "col text-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "intro-banner-inline-video__text",
        dangerouslySetInnerHTML: {
          __html: settings.content.html
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "intro-banner-link",
        dangerouslySetInnerHTML: {
          __html: settings.link.html
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col video-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "intro-banner-inline-video__video"
      }, /*#__PURE__*/React.createElement("iframe", {
        src: hasConsent ? settings.embeddedVideo.src : '',
        title: "video-player",
        frameBorder: "0",
        height: settings.embeddedVideo.height,
        width: settings.embeddedVideo.width
      })), !hasConsent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, dictionary.Shared.videoCannotBeLoadedDueToCookieConsentError))));
    }

    // default view, centered in frame
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "intro-banner-inline-video__text",
      dangerouslySetInnerHTML: {
        __html: settings.content.html
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "intro-banner-inline-video__video"
    }, /*#__PURE__*/React.createElement("iframe", {
      src: hasConsent ? settings.embeddedVideo.src : '',
      title: "video-player",
      frameBorder: "0",
      height: settings.embeddedVideo.height,
      width: settings.embeddedVideo.width,
      style: {
        display: !hasConsent ? 'none' : 'inline'
      }
    })), !hasConsent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, dictionary.Shared.videoCannotBeLoadedDueToCookieConsentError)), /*#__PURE__*/React.createElement("div", {
      className: "intro-banner-link",
      dangerouslySetInnerHTML: {
        __html: settings.link.html
      }
    }));
  };

  // main view render
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "intro-banner-inline-video__outer-pos-wrapper ".concat(anchorStyle, " ").concat(mobileStyle),
    style: {
      backgroundImage: backgroundImage(),
      minHeight: minHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "intro-banner-inline-video__inner-pos-wrapper"
  }, renderContentSection()), renderAnchorLink()));
};
export default VideoBanner;
VideoBanner.propTypes = {
  settings: PropTypes.shape({
    image: PropTypes.objectOf(PropTypes.any),
    content: PropTypes.objectOf(PropTypes.any),
    embeddedVideo: PropTypes.objectOf(PropTypes.any),
    anchorLink: PropTypes.objectOf(PropTypes.any),
    mobileImage: PropTypes.objectOf(PropTypes.any),
    link: PropTypes.objectOf(PropTypes.any)
  }).isRequired,
  component: PropTypes.objectOf(PropTypes.any).isRequired
};